import React, { cloneElement, useEffect, useRef, useState } from 'react';
import linkedinLogo from "../../assetFiles/LI-Logo.png"
import gmailLogo from "../../assetFiles/gmailLogo.png"
import githubLogo from "../../assetFiles/GitHub_Logo.png"

const BinaryRain = ({ myImage, myHeader, myText, wipeSpeed = 0.9, 
    experienceHeader, experienceImage, experienceDesc,
    resumeHeader, isPdf = false, pdfLink, pdfPreview, pdfText
}) => {
    const canvasRef = useRef(null);
    const [showContent, setShowContent] = useState(false);
    const [showImage, setShowImage] = useState(false);
    const [showHeader, setShowHeader] = useState(false);
    const [showText, setShowText] = useState(false);
    const [imageError, setImageError] = useState(false);

    const [showExperienceHeader, setShowExperienceHeader] = useState(false)
    const [showExperienceImage, setShowExperienceImage] = useState(false)
    const [showExperienceDesc, setShowExperienceDesc] = useState(false)
    const [showExperienceContent, setShowExperienceContent] = useState(false)

    const [showResumeHeader, setShowResumeHeader] = useState(false)
    const [showResumeFile, setShowResumeFile] = useState(false)
    const [showResumePreview, setShowResumePreview] = useState(false)
    const [showResumeContent, setShowResumeContent] = useState(false)

    const [showNavbar, setShowNavbar] = useState(false);
    const navbarHeight = 60;

    const [showFooter, setShowFooter] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
    
    function resizeCanvas() {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
    }

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const binary = '01';
    const fontSize = 20;
    const columns = Math.floor(canvas.width / fontSize);
    const drops = new Array(columns).fill(0);

    // Speed control variables
    const dropSpeed = wipeSpeed; // Adjust this to change speed
    const frameInterval = Math.max(1, Math.floor(33 / wipeSpeed)); // Minimum 1ms interval

    function draw() {
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
        ctx.font = `${fontSize}px monospace`;

        let allDropsCompleted = true;

        for (let i = 0, y; i < drops.length; i++) {
            const text = binary[Math.floor(Math.random() * binary.length)];
            const x = i * fontSize;
            y = drops[i] * fontSize;  // Add navbarHeight here
            
            ctx.fillText(text, x, y);
        
            if (y < canvas.height) {
                drops[i] += dropSpeed;
                allDropsCompleted = false;
            }
        }

        return !allDropsCompleted;
    }

    function animate() {
        if (draw()) {
            requestAnimationFrame(animate)
        } else {
            sessionStorage.setItem('binaryRainBackground', canvas.toDataURL());
            setShowContent(true);
            setTimeout(() => setShowImage(true), 500);
            setTimeout(() => setShowHeader(true), 1500);
            setTimeout(() => setShowText(true), 2500);

            setTimeout(() => setShowExperienceContent(true), 3500);
            setTimeout(() => setShowExperienceHeader(true), 3500)
            setTimeout(() => setShowExperienceImage(true), 3500)
            setTimeout(() => setShowExperienceDesc(true), 3500)

            setTimeout(() => setShowResumeContent(true), 4500)
            setTimeout(() => setShowResumeHeader(true), 4500)
            setTimeout(() => setShowResumeFile(true), 4500)
            setTimeout(() => setShowResumePreview(true),4500)

            setTimeout(() => setShowNavbar(true), 5500);
            setTimeout(() => setShowFooter(true), 5500);
        }
    }

    animate();

    return () => {
        window.removeEventListener('resize', resizeCanvas);
    };
    }, [wipeSpeed]);

    const handleImageError = () => {
        console.error("Failed to load image");
        setImageError(true);
    };

  return (
    <>
        <div style={{ display: 'flex', width: '100vw', height: '100vh', overflow: 'hidden', background: 'black' }}>
            <div style={{
                position: 'fixed',
                top: '30px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '95%',
                zIndex: 2,
                opacity: showNavbar ? 1 : 0,
                transition: 'opacity 1s ease-in',
            }}>
                <div style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.9)',
                    border: '2px solid #333',
                    borderRadius: '15px',
                    padding: '10px',
                    boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    justifyContent: 'space-around',
                    alignItems: 'center'
                }}>
                    <a href="/Home" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
                    <a href="/Education" style={{ color: 'white', textDecoration: 'none' }}>Education</a>
                    <a href="/Experience" style={{ color: 'white', textDecoration: 'none' }}>Experience</a>
                    <a href="/Leadership" style={{ color: 'white', textDecoration: 'none' }}>Leadership</a>
                    <a href="/Projects" style={{ color: 'white', textDecoration: 'none' }}>Projects</a>
                    <a href="/Skills" style={{ color: 'white', textDecoration: 'none' }}>Skills</a>
                </div>
            </div>
            <div style={{ width: '50%', height: '100%', position: 'relative', backgroundColor: 'black'}}>
                <canvas ref={canvasRef} style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }} />
                <div style={{
                    opacity: showContent ? 1 : 0,
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1,
                    width: '80%',
                    maxHeight: '70%',
                    overflow: 'auto',
                    transition: 'opacity 1s ease-in',
                }}>
                    <div style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        border: '2px solid #333',
                        borderRadius: '15px',
                        padding: '20px',
                        boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                        marginTop: '43px',
                        marginLeft:'70px',
                        minHeight: 'fit-content'
                    }}>
                        {imageError ? (
                            <div style={{ color: 'red', marginBottom: '20px' }}>Failed to load image</div>
                        ) : (
                        <img 
                            src={myImage} 
                            alt="User provided image" 
                            onError={handleImageError}
                            style={{ 
                                opacity: showImage ? 1 : 0,
                                maxWidth: '300px', 
                                maxHeight: '350px',
                                objectFit: 'contain',
                                marginBottom: '20px',
                                transition: 'opacity 1s ease-in',
                                borderRadius: '10px'
                            }} 
                        />
                        )}
                        <h2 style={{
                                opacity: showHeader ? 1 : 0,
                                transition: 'opacity 1s ease-in',
                                marginBottom: '10px',
                                color: 'white'
                            }}>
                            {myHeader}
                        </h2>
                        <p style={{
                            opacity: showText ? 1 : 0,
                            transition: 'opacity 1s ease-in',
                            color: 'white'
                            }}>
                            {myText}
                        </p>
                    </div>
                </div>
            </div>
            {/* other side */}
            <div style={{ 
                    width: '50%', 
                    height: '100%', 
                    backgroundColor: 'black', 
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    background: 'black'
                }}>
                <div style={{
                        opacity: showExperienceContent ? 1 : 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        border: '2px solid #333',
                        borderRadius: '15px',
                        boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                        zIndex: 1,
                        width: '30vw',
                        transition: 'opacity 1s ease-in',
                        height: 'fit-content'
                    }}>
                    <h2 style={{
                            opacity: showExperienceHeader ? 1 : 0,
                            transition: 'opacity 1s ease-in',
                            marginBottom: '10px',
                            color: 'white'
                        }}>
                        {experienceHeader}
                    </h2>    
                    {imageError ? (
                        <div style={{ color: 'red', marginBottom: '20px' }}>Failed to load image</div>
                    ) : (
                    <img 
                        src={experienceImage} 
                        alt="User provided image" 
                        onError={handleImageError}
                        style={{ 
                            opacity: showExperienceImage ? 1 : 0,
                            maxWidth: '70px', 
                            maxHeight: '70px',
                            objectFit: 'contain',
                            marginBottom: '0px',
                            transition: 'opacity 1s ease-in',
                            borderRadius: '10px',
                            border: 'solid 1px white'
                        }} 
                    />
                    )}
                    <p style={{
                            opacity: showExperienceDesc ? 1 : 0,
                            transition: 'opacity 1s ease-in',
                            color: 'white',
                            whiteSpace: 'pre-wrap',  // This allows line breaks
                            wordWrap: 'break-word'  // This ensures long words don't overflow
                        }}>
                        {experienceDesc}
                    </p>
                </div>
                <div style={{
                        opacity: showResumeContent ? 1 : 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        border: '2px solid #333',
                        borderRadius: '15px',
                        boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                        zIndex: 1,
                        width: '30vw',
                        maxHeight: '28vh',
                        transition: 'opacity 1s ease-in',
                        verticalAlign: 'middle',
                        alignItems: 'center',
                        marginTop: '20px',
                        height: 'fit-content'
                    }}>
                    <h2 style={{
                            opacity: showResumeHeader ? 1 : 0,
                            transition: 'opacity 1s ease-in',
                            marginBottom: '15px',
                            color: 'white'
                        }}>
                        {resumeHeader}
                    </h2>    
                    <img 
                        src={pdfPreview} 
                        alt="User provided image" 
                        onError={handleImageError}
                        style={{ 
                            width: '50%', 
                            height: '50%',
                            objectFit: 'scale-down',
                            marginBottom: '5px',
                            transition: 'opacity 1s ease-in',
                            borderRadius: '10px',
                        }} 
                    />
                    {isPdf ? (
                        <a href={pdfLink} target="_blank" rel="noopener noreferrer" style={{ color: 'white', display: 'block'}}>
                        View Resume
                        </a>
                    ) : (
                        <p style={{ color: 'white' }}>{pdfText}</p>
                    )}
                </div>
            </div>  
                <div style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '95%',
                        zIndex: 2,
                        opacity: showFooter ? 1 : 0,
                        transition: 'opacity 1s ease-in'
                    }}>
                    <div style={{
                            backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            border: '2px solid #333',
                            borderRadius: '15px',
                            padding: '10px',
                            boxShadow: '0 0 10px rgba(255, 255, 255, 0.1)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                        <span style={{ color: 'white' }}>© 2024 Steven Huang | Product Manager & Developer | v1.2 | stevenhuangtech@gmail.com</span>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center'  // This ensures vertical centering of the buttons
                            }}>
                            <span style={{ color: 'white'}}>Interested? Feel free to contact me! ---{'>'} </span>
                            <a 
                                href="mailto:stevenhuangtech@gmail.com" 
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.7}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={gmailLogo}
                                    alt="Email"
                                    style={{
                                        width: '20px',
                                        height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://github.com/huangs-nyc" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '70px',
                                height: '20px'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                                >
                                <img 
                                    src={githubLogo} 
                                    alt="Github"
                                    style={{
                                    width: '50px',
                                    height: '20px'
                                    }}
                                />
                            </a>
                            <a 
                                href="https://www.linkedin.com/in/steven-huang-a60a8a22a/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                style={{
                                backgroundColor: 'white',
                                border: 'none',
                                padding: '5px',
                                margin: '0 5px',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '100px',
                                height: '20px'
                            }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = 0.9}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = 1}
                            >
                            <img 
                                src={linkedinLogo} 
                                alt="LinkedIn"
                                style={{
                                width: '80px',
                                height: '20px'
                                }}
                            />
                            </a>
                        </div>
                    </div>
            </div>
        </div>
    </>
  );
};

export default BinaryRain;